import { NavLink } from "react-router-dom"

const MobileBtn = (props) => {
    return (
        <NavLink to={props.to} className={(navData) => (navData.isActive ? 'text-white underline' : '') + ['bg-forest-green-web py-2 rounded px-5 hover:text-white hover:underline cursor-pointer border']}>{props.name}</NavLink>
    )
}

export default MobileBtn